let configLocal = require('./config-local');

let config = {
    instanceId: '#INSTANCE_ID#',
    redisHost: '#REDIS_HOST#',
    redisPort: '#REDIS_PORT#',
    wsHost: '#WS_HOST#',
    wsPort: '#WS_PORT#',
    secure: '#SECURE',
    sslCertificatePath: '#SSL_CERTIFICATE_PATH#',
    sslCertificateKey: '#SSL_CERTIFICATE_KEY#'
};

module.exports = Object.assign(config, configLocal);